import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import SalesRuleForm from 'Services/ProductManagement/Features/SalesRule/Components/SalesRuleForm'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { PRODUCT_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function SalesRuleCreatePage() {
  const baseUrl = `${PRODUCT_MANAGEMENT_ROOT_URL}/settings/sales-rules`
  const previousLocation = usePreviousLocation(baseUrl)
  const breadcrumbs = [
    {
      title: t`Settings`
    },
    {
      title: t`Sales rules`,
      link: baseUrl
    },
    {
      title: t`Create new sales rule`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create sales rule`}</PageTitle>
        </Grid>
      </Grid>
      <SalesRuleForm successBaseUrl={previousLocation} />
    </Box>
  )
}
